import algoliasearch from 'algoliasearch';
import { environment } from '../../../../environments/environment';

export const ALOGLIA_CONFIG = {
  indexName: environment.algolia.listingIndexName,
  searchClient: algoliasearch(
    environment.algolia.appId,
    environment.algolia.searchAPIKey
  ),
  insightsClient: (window as any).aa,
};
